"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionTypes = void 0;
var actionTypes = {
  FETCH: "@@rgcp-html-map/fetch",
  LIST: "@@rgcp-html-map/list",
  DELETE: "@@rgcp-html-map/delete",
  ADD: "@@rgcp-html-map/add",
  UPDATE: "@@rgcp-html-map/update",
  RESET: "@@rgcp-html-map/reset",
  SUCCESS: "@@rgcp-html-map/success",
  ERROR: "@@rgcp-html-map/error",
  SOFT_DELETE: "@@rgcp-html-map/soft-delete",
  SOFT_DELETE_RESTORE: "@@rgcp-html-map/soft-delete-restore",
  SOFT_DELETED_LIST: "@@rgcp-html-map/soft-deleted-list",
  BULK_SOFT_DELETE: "@@rgcp-html-map/bulk-soft-delete",
  BULK_RESTORE: "@@rgcp-html-map/bulk-restore",
  BULK_HARD_DELETE: "@@rgcp-html-map/bulk-hard-delete"
};
exports.actionTypes = actionTypes;